import axios from '@axios'

const PREFIX = '/orgaos-emissores'

export default {

  getOrgaosEmissoresResumidos(filtro, externo) {
    if (externo) {
      return axios.post(`${PREFIX}/portal-propostas/resumido`, filtro)
    }
    return axios.post(`${PREFIX}/resumido`, filtro)
  },
}
